import React from 'react';
import {CircularProgress,} from "@material-ui/core";
import {useTranslation} from "react-i18next";


const AppLoader2 = ({loading, children}) => {
    const {t} = useTranslation()
    if (!loading) {
        return <>
            {children}
        </>;
    } else {
        return <>
            < CircularProgress style={{color: "#FCB01F",position:"absolute"}}/>
            {children}
        </>
    }
};

export default AppLoader2;